import styled from "styled-components";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const GreyContainer = styled.div`
  background-color: ${colours.backgroundGrey};
  padding-bottom: 0.1em;
`;

export const Header = styled.h2`
  color: ${colours.elexonBlack};
  padding-top: 0.75em;
  background-color: transparent;

  && {
    margin-bottom: 2em;
    font-size: ${fonts.large};
    font-weight: ${fontWeights.heavy};
  }
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 2em;
  background: transparent;
  margin: 24px 0;
`;

export const LinkSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;

  ${LinksContainer} &:not(:last-child) {
    border-right: 1px solid ${colours.elexonBlue};
  }
`;

export const LinkContentDiv = styled.div`
  h3 {
    color: ${colours.elexonBlack};
    font-size: ${fonts.mediumSmaller};
    margin-bottom: 1em;
  }

  p {
    color: ${colours.darkGrey};
    font-size: ${fonts.small};
    padding-right: 2em;
    margin-bottom: 4em;
  }
`;
